import type { MetroAnalyticsReporter } from '../interaction/metroAnalyticsReporter'
import type { Effect } from './metroMapStore'

export interface EffectRuntime {
  logger: (message: string) => void
  reporter: MetroAnalyticsReporter
}

export function runEffects(effects: readonly Effect[], runtime: EffectRuntime): void {
  for (const e of effects) {
    switch (e.kind) {
      case 'LogTap':
        runtime.logger(e.message)
        break
      case 'ReportError':
        runtime.reporter(e.event, e.metadata)
        break
      case 'ReportEvent':
        // Product analytics event (G-1). Same reporter sink as ReportError;
        // the distinction is semantic (behaviour event vs. diagnostic).
        runtime.reporter(e.event, e.params)
        break
    }
  }
}
